import PropTypes from 'prop-types'
import Link from '@components/link'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import { ListRelatedRoot } from './list-related.styles'

const ListRelated = (props) => {
  const {
    linksCollection: { items },
    headline,
  } = props

  return (
    <ListRelatedRoot fontSize={[14, 14, 16]} mb={[4, 4, 4]}>
      {headline && <Typography variant="h5" gutterBottom>{headline}</Typography>}
      {items && items.map((item) => {
        const series = item.cat && (item.cat.series || item.cat.category)
        return (
          <div key={item.sys.id}>
            <Box fontWeight="bold" mt={1} mb={0.25} data-gtm-category={series}>{series}</Box>
            <Link {...item}>
              {item.headline}
            </Link>
          </div>
        )
      })}
    </ListRelatedRoot>
  )
}

ListRelated.propTypes = {
  headline: PropTypes.string,
  linksCollection: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({
      headline: PropTypes.string,
    })),
  }),
}

ListRelated.defaultProps = {
  linksCollection: {
    items: [],
  },
}

export default ListRelated
